import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "voucher-service";

export default {
    getVouchers(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/voucher/list/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveVoucher(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/voucher/add",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewVoucher(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/voucher/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    deleteVoucher(param) {
        // console.log(param);
        // console.log(auth.getHeader());
        // console.log(BASE_SERVICE_URL);
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/voucher/delete",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateVoucher(uuid, param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/voucher/update/" + uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    exportVouchers(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/voucher/export",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
};